// extracted by mini-css-extract-plugin
export default {"container":"ResultsLayout_container__zrnnz","header":"ResultsLayout_header__pCSnx","main":"ResultsLayout_main__UwuZz","spinner-container":"ResultsLayout_spinner-container__JmcVH"};